export default function ColumnRight(props){
    return <div className="flex-col sm:flex items-center justify-center relative py-8 sm:py-10 lg:py-4">
        {props.children}
    </div>
}